import React from 'react';
import { LearningScene } from './learningAssets';

/*
 * ProductAtmosphere keeps the shell recognisable while each route retains its
 * own job. It deliberately uses the same semantic scenes as the dashboard:
 * memory is a signal map, the Hub is a shelf, practice modes are instruments.
 * The visual is background-only, so it never competes with learning content.
 */
const SCREEN_SCENES = {
  home: 'memory',
  settings: 'theory',
  plan: 'theory',
  hub: 'hub',
  hub2: 'hub',
  memory: 'memory',
  path: 'hub',
  community: 'interview',
  creatorpage: 'interview',
  discover: 'interview',
  nav: 'dsa',
  profile: 'memory',
  voice: 'interview',
  report: 'interview',
  rapidfire: 'rapidfire',
  blitz: 'rapidfire',
};

const MODE_SCENES = {
  dsa: 'dsa',
  mcq: 'quiz',
  theory: 'theory',
  flashcards: 'flashcards',
  interviewer: 'interview',
  rapidfire: 'rapidfire',
  blitz: 'rapidfire',
};

const sceneFor = (screen, mode) => (
  screen === 'chat' ? (MODE_SCENES[mode] || 'theory') : (SCREEN_SCENES[screen] || 'memory')
);

export default function ProductAtmosphere({ screen, mode }) {
  const scene = sceneFor(screen, mode);
  return (
    <div className={`dv-atmosphere dv-atmosphere--${scene} dv-atmosphere--${screen}`} aria-hidden="true">
      <span className="dv-atmosphere-grid" />
      <span className="dv-atmosphere-halo dv-atmosphere-halo--one" />
      <span className="dv-atmosphere-halo dv-atmosphere-halo--two" />
      <span className="dv-atmosphere-rule" />
      <div className="dv-atmosphere-scene">
        <LearningScene name={scene} size={132} />
      </div>
    </div>
  );
}
